export var Model={style:{width:String,height:String},width:Number,height:Number,aligntop:Boolean};export default function Upright(args){return _.assignDeep(Model,args)}


//////////////////
// WEBPACK FOOTER
// ./app/components/models/upright.js
// module id = 215
// module chunks = 0